import I, { forwardRef as K, useRef as m, useEffect as o } from "react";
import { Chart as j } from "./index.es222.js";
const b = "label";
function p(t, e) {
  typeof t == "function" ? t(e) : t && (t.current = e);
}
function D(t, e) {
  const a = t.options;
  a && e && Object.assign(a, e);
}
function y(t, e) {
  t.labels = e;
}
function C(t, e) {
  let a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : b;
  const i = [];
  t.datasets = e.map((r) => {
    const s = t.datasets.find((d) => d[a] === r[a]);
    return !s || !r.data || i.includes(s) ? {
      ...r
    } : (i.push(s), Object.assign(s, r), s);
  });
}
function E(t) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : b;
  const a = {
    labels: [],
    datasets: []
  };
  return y(a, t.labels), C(a, t.datasets, e), a;
}
function O(t, e) {
  const { height: a = 150, width: i = 300, redraw: r = !1, datasetIdKey: s, type: d, data: u, options: c, plugins: w = [], fallbackContent: R, updateMode: h, ...v } = t, l = m(null), n = m(null), f = () => {
    l.current && (n.current = new j(l.current, {
      type: d,
      data: E(u, s),
      options: c && {
        ...c
      },
      plugins: w
    }), p(e, n.current));
  }, g = () => {
    p(e, null), n.current && (n.current.destroy(), n.current = null);
  };
  return o(() => {
    !r && n.current && c && D(n.current, c);
  }, [
    r,
    c
  ]), o(() => {
    !r && n.current && y(n.current.config.data, u.labels);
  }, [
    r,
    u.labels
  ]), o(() => {
    !r && n.current && u.datasets && C(n.current.config.data, u.datasets, s);
  }, [
    r,
    u.datasets
  ]), o(() => {
    n.current && (r ? (g(), setTimeout(f)) : n.current.update(h));
  }, [
    r,
    c,
    u.labels,
    u.datasets,
    h
  ]), o(() => {
    n.current && (g(), setTimeout(f));
  }, [
    d
  ]), o(() => (f(), () => g()), []), /* @__PURE__ */ I.createElement("canvas", {
    ref: l,
    role: "img",
    height: a,
    width: i,
    ...v
  }, R);
}
const k = /* @__PURE__ */ K(O);
export {
  k as Chart
};
//# sourceMappingURL=index.es223.js.map
